exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail[data-v-46ae9e88]{height:500px}.detail[data-v-46ae9e88] .el-table__body-wrapper{height:90%!important}", ""]);

// exports
